import React, { useEffect, useRef, useState } from 'react';
import './Sandwich.scss';
import { setScrollNaming } from '../../Services/ScrollURL';
import { GA_Push } from '../../Services/GoogleAnalytics';

const Sandwich = (props) => {
    const [toTransformCoupon, setToTransformCoupon] = useState(false);
    const [transform, toggleTransform] = useState(`translateY(100vh)`);
    const [reScroll, setReScroll] = useState(false);
    const section = useRef(null);
    const {
        currentScreen
    } = props;

    // useEffect(() => {

    //     setScrollNaming(section.current);
    // }, [])

    useEffect(() => {
        
        // currentScreen >= 2 && currentScreen <= 6 && !reScroll ? setToTransformCoupon(true) : setToTransformCoupon(false);
        currentScreen >= 2 && setReScroll(true);

        if (currentScreen == 0 && reScroll) {
            // setToTransformCoupon(false);
            toggleTransform(`translateY(0vh)`);
        }
        else if (currentScreen >= 1 && currentScreen <= 6 && reScroll) {
            setToTransformCoupon(true);
            toggleTransform(`translateY(${(currentScreen - 1) * 100}vh)`)
        } else if (currentScreen === 7 && reScroll) {
            // setToTransformCoupon(false);
            toggleTransform(`translateY(500vh)`);
        }


    }, [currentScreen, reScroll]);

    useEffect(() => {
        // toTransformCoupon ? toggleTransform(`translateY(${(currentScreen - 1) * 100}vh)`) : "";
    }, [currentScreen]);

    return (
        <section className="section section-sandwich" ref={section}>
            <div className="line-through"></div>
            <div className="padding">
                <div className="container">
                    <div className="header"></div>
                    <div className="main-text"></div>
                </div>
                <div
                    style={{
                        transform: toTransformCoupon ? transform : "",
                        transition: "transform 1.5s ease"
                    }}
                    onClick={() => {
                        GA_Push("Coupon clicked", "", "Coupon_Events", "Coupon");
                        window.open("http://www.tara.co.il/%D7%A7%D7%95%D7%A4%D7%95%D7%A0%D7%99%D7%9D/", "_blank")
                    }}
                    className="coupon"></div>
                <div className="emental"></div>
            </div>
        </section>
    )
}

export default Sandwich



// WEBPACK FOOTER //
// ./src/Components/Screens/1_Sandwich/Sandwich.jsx